import type { UIComponent } from '~/services/layout/index.ts';
import type { StorageFeedsData } from '../ui-component';
import type { UseIsLoggedInReturnType } from '~/hooks/use-is-logged-in';
import { ClientFeedWrapper } from './client-feed-wrapper';

export type Props = {
  Component: (props: any) => JSX.Element;
  uiComponent: UIComponent;
  storageFeedsData: StorageFeedsData;
  isLoggedInData: UseIsLoggedInReturnType;
  forceFresh?: boolean;
};

function ClientUiComponent({
  Component,
  uiComponent,
  storageFeedsData,
  isLoggedInData,
  forceFresh,
}: Props): JSX.Element {
  return (
    <ClientFeedWrapper
      uiComponent={uiComponent}
      forceFresh={forceFresh}
      render={({ feed, isClient, isLoading }) => (
        <Component
          isClient={isClient}
          isLoading={isLoading}
          uiComponent={uiComponent}
          feed={feed}
          storageFeedsData={storageFeedsData}
          isLoggedInData={isLoggedInData}
        />
      )}
    />
  );
}

export default ClientUiComponent;
